import Button from "components/UI/Button";
import { HookInput } from "components/UI/HookForm/Form/Input";
import { useApplicationFormContext } from "features/ApplicationForm/ApplicationFormProvider";

const Disclosure = () => {
  const today = new Date();
  const { setCurrentStep } = useApplicationFormContext();

  return (
    <>
      <div className="p-6 space-y-4">
        <h3 className="text-primaryColor-normal pb-6">Submitter Signature </h3>
        <div className="space-y-6">
          <section className="space-y-4">
            <p className="font-bold">
              By submitting this application you are attesting that the
              information is accurate and true to the best of your knowledge.
            </p>
            <div className="space-y-4 py-4">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </div>
          </section>
        </div>
        <p className="font-bold py-4">
          *Please note that incomplete applications will not be considered for
          funding.
        </p>
        <p className="font-bold py-4">
          Please Type your name below to serve as your signature and
          authorization to process this application.
        </p>
        <section className="py-4 w-1/3 space-y-4">
          <HookInput
            customClassName="col-span-3"
            label="Name of Grantee Organization"
            id="grantee-organization-name"
            name="step5.granteeName"
            type="text"
          />
          <HookInput
            customClassName="col-span-3"
            label="Authorized Representative "
            id="applicant-name"
            name="step5.authorizedRepresentative"
            type="text"
          />

          <p>Date: {today.toLocaleDateString()}</p>
        </section>
        <div className="flex gap-4 justify-end mt-5">
          <Button
            label="Previous"
            btnStyle="neutral"
            type="button"
            onClick={() => setCurrentStep((prev) => prev - 1)}
          />
          <Button label="Next" btnStyle="primary" type="submit" />
        </div>
      </div>
    </>
  );
};

export default Disclosure;
